import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { NgForm } from '@angular/forms';
import { ChangeDetectionStrategy } from '@angular/core';
import { EscolaridadService } from '../../services/escolaridad/escolaridad.service';
import { ProductosService } from 'src/app/services/productos/productos.service';
import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';
import { PostulacionesService } from 'src/app/services/postulaciones/postulaciones.service';
import { AfiliacionService } from 'src/app/services/afiliacion/afiliacion.service';
import { Usuario } from '../../models/usuario/usuario.model';
import { ConfirmationDialog } from '../confirmation-dialog/confirmation-dialog.component';
import Swal from 'sweetalert2';
import { environment } from '../../../environments/environment';


declare const Rut: any;
declare const ageCalculator: any;

@Component({
    selector: 'app-solicitud-afiliacion',
    templateUrl: '../../pages/solicitud-afiliacion/solicitud-afiliacion.component.html',
    styleUrls: ['../../pages/solicitud-afiliacion/solicitud-afiliacion.component.css'],
    changeDetection: ChangeDetectionStrategy.Default
})
export class SolicitudAfiliacionComponent implements OnInit, OnDestroy {

    rol: string = localStorage.getItem("rol")
    nombreUsuario: string = localStorage.getItem("nombreUsuario")
    rutUsuario: any;
    randomString: string;
    diasDiferencia: any;
    mostrarCaip: boolean;
    mostrarDatosCargados: boolean;
    mostrarTerminosContinuar: boolean;
    mostrarCalidadJuridica: boolean;
    sumatoriaCupoOcupado: any;
    cursos: any[]; postulantes: any[];

    escolaridad = {
        afiliado: "", beneficiario: "", etapaEscolar: "", fechaCertificado: "", email: "",
        archivo: { bytes: null, tipo: null }, archivoTest: null
    }

    afiliado: any = { rutAfiliado: "", nombres: "", idAfiliado: '', email: '', nombreAfiliado: '', apellidoAfiliado: '' };
    data: any = { rutAfiliado: "", calidadJuridicaCodigo: 0, nombres: "", idAfiliado: "", email: "", fechaActual: "", scales: false }
    constructor(private router: Router, private escolaridadService: EscolaridadService,
        private productosService: ProductosService, private dialog: MatDialog,
        private postulacionesService: PostulacionesService, private afiliacionService: AfiliacionService) { }

    ngOnInit(): void {
        let vm = this
        const tiempoTranscurrido = Date.now();
        const hoy = new Date(tiempoTranscurrido);
        this.data.fechaActual = hoy.toLocaleDateString();
        this.data.mostrarDatosCargados = false;
        this.data.mostrarTerminosContinuar = false;
        this.data.mostrarCalidadJuridica = false;

    }
    ngOnDestroy(): void {
    }

    BuscarAfiliadoExterno(rutExterno) {
        let vm = this

        let rutDigitado = rutExterno

        if (Rut(rutExterno)) {
            let rut = rutDigitado.split('.').join('').split('-')[0]
            this.traePostulantes(rutDigitado)
        }
        else { this.openAlertDialog('El RUT es incorrecto. Favor Revisar.', 'btn-danger') }
    }

    MostrarCaip(mostrar) {
        let vm = this

        if (mostrar) {
            this.data.mostrarTerminosContinuar = false
            this.data.mostrarCaip = true
            this.data.mostrarCalidadJuridica = false;
        } else {
            this.data.mostrarTerminosContinuar = true
            this.data.mostrarCaip = false
            this.data.mostrarCalidadJuridica = false;
        }

    }


    redireccionarCAIP() {
        document.location.href = 'https://eccnetserver.entelcallcenter.cl/junji_formulario_crm/Main.aspx';
    }

    redireccionarHome() {
        this.router.navigate(['/login']);
    }



    generateRandomString(length: number): string {
       const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
       let result = '';
       const charactersLength = characters.length;
    
       for (let i = 0; i < length; i++) {
          const randomIndex = Math.floor(Math.random() * charactersLength);
          result += characters.charAt(randomIndex);
       }
       return result;
      }
    


    AceptarPostulacion() {
        this.randomString = this.generateRandomString(300); 
        let vm = this
        if (!this.data.scales) {
            this.openAlertDialog('Solo se puede aceptar la solicitud de afiliación en caso que sean aceptados los Términos y Condiciones.', 'btn-danger')
            return false;
        }

        localStorage.setItem("rutAfiliado", vm.data.rutAfiliado);

        document.location.href = `${environment.urlClaveUnica}` + "openid/authorize/" +
            "?client_id=" + `${environment.clienteId}` +
            "&response_type=code" +
            "&scope=openid run name" +
            "&redirect_uri=" + `${environment.claveRedirectUri}` +
            "&state=" + this.randomString;
          

    }

    seleccionaArchivo(event: any) {
        let vm = this
        if (event.target.files.length > 0) {
            this.escolaridad.archivo.tipo = event.target.files[0].type
            let reader = new FileReader()

            reader.readAsDataURL(event.target.files[0])

            reader.onload = function () {
                vm.escolaridad.archivo.bytes = reader.result

                console.log(vm.escolaridad.archivo.bytes)
            }
        }
    }


    traePostulantes(rut: any) {
        var vm = this
        this.afiliacionService.validaAfiliadoPorRut(rut.split('-')[0],true).then
            (
                (sumatoriaCupoOcupado) => {
                   
                    this.afiliacionService.traeAfiliadoGesdep(rut).then
                        (
                            (usuario: Usuario) => {
                                vm.data.email = usuario.correoElectronico
                                vm.data.nombres = usuario.nombres + ' ' + usuario.apellidoPaterno + ' ' + usuario.apellidoMaterno
                               
                                if (usuario.calidadJuridicaCodigo == 1 || usuario.calidadJuridicaCodigo == 4 || usuario.calidadJuridicaCodigo == 5) {

                                    this.data.mostrarCaip = false;
                                    this.data.mostrarDatosCargados = true;
                                    this.data.mostrarTerminosContinuar = true;
                                    this.data.mostrarCalidadJuridica = false;
                                } else {
                                    this.data.mostrarCaip = false;
                                    this.data.mostrarDatosCargados = false;
                                    this.data.mostrarTerminosContinuar = false;
                                    this.data.mostrarCalidadJuridica = true;
                                    this.openAlertDialog("Su calidad jurídica no cumple con requisito para cursar solicitud de afiliación según reglamento (Decreto 28, Titulo III Art.7°) ", 'btn-danger')
                                }
                            }
                        )
                        .catch
                        (
                            error => {
                                console.log(error)
                                Swal.close();
                                vm.openAlertDialog('No se han encontrado usuarios con el RUT ingresado. Intente nuevamente.', 'btn-dark')
                            }
                        )
                }
            )
            .catch
            (
                error => {
                    console.log("error.status:::",error.status)
                    console.log("error.status.message:::",error.error.message)
                   
                    if (error.error.message == 406) {
                        this.openAlertDialog('El rut del usuario ya existe en BIENESTAR CUENTA CORRIENTE, favor contactarse con un ejecutivo.', 'btn-danger')
                        vm.data.email=''
                        vm.data.nombres=''
                        this.data.mostrarDatosCargados = false;
                        this.data.mostrarTerminosContinuar = false;
                        Swal.close();
                    } else if (error.status == 500) {
                        this.openAlertDialog(error.error.message, 'btn-danger')
                        vm.data.email=''
                        vm.data.nombres=''
                        this.data.mostrarDatosCargados = false;
                        this.data.mostrarTerminosContinuar = false;
                        Swal.close();
                    } else {
                        console.log(error)
                        this.openAlertDialog('Ocurrió un error al gestionar una solicitud de afiliación.', 'btn-danger')
                        Swal.close();
                    }
                }
            )

    }



    openAlertDialog(mensaje: string, clase: string) {
        this.dialog.open(AlertDialogComponent, {
            data: { message: mensaje, clase: clase, buttonText: { cancel: 'Listo!' }, }
        })
    }

    salir() {
        const dialogRef = this.dialog.open(ConfirmationDialog, {
            data: { message: '¿Esta seguro de salir del formulario?', buttonText: { ok: 'Si', cancel: 'No' } }
        });

        dialogRef.afterClosed().subscribe((confirmed: boolean) => {
            if (confirmed) { this.router.navigate(['/index']); }
        });
    }
}
